var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #4899d4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N4Saco"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.21,92.15c0-.88.48-7.52.28-11.86-.25-5.54-1.58-8.61-8.19-8.61l-11.89-.05c-1.41,1.99-2.82,3.96-4.23,5.9l13.29.04h2.54c1.27.01,3.11,1.16,3.11,4.27v10.74l-77.08-.15c-3.25,0-4.94,2.4-6.14,6.04l-10.52,31.98v-62.3c0-1.2.99-2.7,3.25-2.7h23.72c1.84,0,3.95.1,4.38,2.98.44,2.97.14,5.87.14,5.65.01-1.89-.47,2.87,2.4,3.31l14.75.05-4.27-5.96-6.04-.03c-1.79,0-1.62-3.4-1.62-7.26,0-2.68-3.37-4.66-5.22-4.66-4.87,0-24-.11-29.01-.11-5.82,0-8.41,4.9-8.51,10.48-.03,25.21-.59,53.44,0,78.08.18,7.42,2.65,10.5,10.5,10.5,27.61,0,58.08,0,86.09,0,4.66.15,7.63-2.72,9.2-6.8,2.85-7.45,10.01-42.2,11.64-50.09,2.57-12.42-12.56-7.65-12.56-9.46ZM142.27,104.71c-2.02,10.24-7.33,31.14-10.02,41.36-.95,3.59-1.86,6.37-4.8,6.37H37.89c-1.36,0-1.79-1.49-1.35-2.3,0,0,16.09-48.54,16.69-50.69.6-2.15,2.64-2.01,3.49-2.01h84.17c3.08,0,1.77,5.3,1.38,7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.38,52.13v-30.24h17.22v30.74c4.72-1.67,16.79-7.21,12.37,3.01-7.1,9.65-13.92,19.5-20.85,29.27-.25.36.1.86-.89.63l-21-31.67c-1.54-8.05,9.3-2.12,13.14-1.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFolder);
export default __webpack_public_path__ + "static/media/blue-Folder.317833c5e5622495cb72ee44b216b8ae.svg";
export { ForwardRef as ReactComponent };